import {
  ITransportCompanies,
  IServiceMenuComponent,
} from '@/interfaces/interfaceCatalogs';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';

import { ButtonComponent } from '../../../../components/ButtonComponen';
import { InputComponent } from '../../../../components/InputComponent';
import { validationsTransportCompanies } from './validations_form';
import { SwitchComponent } from '../../../../components/SwitchComponent';
import { InputSwitchChangeEvent } from 'primereact/inputswitch';
import useCustomFormik from './utils/formik_catalog_Config';

export const TransportCompaniesForm = (props: IServiceMenuComponent) => {
  const { serviceCatalog } = props;

  const renderMenu = (): any => {
    return (
      <form
        className="h-full w-full flex flex-col pt-5 px-6"
        onSubmit={serviceCatalog.formikTransportCompanies.handleSubmit}>
        <div className="flex flex-col">
          <InputComponent
            label={'Nombre de compañía'}
            type={'businessName'}
            name={'businessName'}
            onChange={serviceCatalog.formikTransportCompanies.handleChange}
            value={serviceCatalog.formikTransportCompanies?.values?.['businessName'] || ''}
            placeholder={'Nombre de compañía/Razón social'}
            className={classNames({
              'p-invalid': serviceCatalog.isFormFieldValid('businessName', serviceCatalog.formikTransportCompanies.errors, serviceCatalog.formikTransportCompanies.touched),
            })}
          />
          {serviceCatalog.getFormErrorMessage('businessName', serviceCatalog.formikTransportCompanies.errors, serviceCatalog.formikTransportCompanies.touched)}
        </div>

        <div className="flex flex-col">
          <InputComponent
            label={'EUR'}
            type={'eur'}
            name={'eur'}
            onChange={serviceCatalog.formikTransportCompanies.handleChange}
            value={serviceCatalog.formikTransportCompanies?.values?.['eur'] || ''}
            placeholder={'EUR'}
            className={classNames({
              'p-invalid': serviceCatalog.isFormFieldValid('eur', serviceCatalog.formikTransportCompanies.errors, serviceCatalog.formikTransportCompanies.touched),
            })}
          />
          {serviceCatalog.getFormErrorMessage('eur', serviceCatalog.formikTransportCompanies.errors, serviceCatalog.formikTransportCompanies.touched)}
        </div>

        <div className="flex flex-col">
          <SwitchComponent
            checked={serviceCatalog.formikTransportCompanies?.values?.['status'] || 'false'}
            onChange={(e: InputSwitchChangeEvent) => {
              serviceCatalog.formikTransportCompanies.setFieldValue('status', e.value);
            }}
            label={'Estatus'}
            className={classNames({
              'p-invalid': serviceCatalog.isFormFieldValid('status', serviceCatalog.formikTransportCompanies.errors, serviceCatalog.formikTransportCompanies.touched),
            })}
          />
          {serviceCatalog.getFormErrorMessage('status', serviceCatalog.formikTransportCompanies.errors, serviceCatalog.formikTransportCompanies.touched)}
        </div>

        <ButtonComponent className="mt-10" label={serviceCatalog.buttonLabel} type="submit" />
      </form>
    );
  };

  return (
    <div className="flex w-full h-full flex-col items-center bg-white  shadow-[-6px_-1px_5px_#00000024] z-10 right-0">
      <div className="flex w-full h-full overflow-y-auto">{renderMenu()}</div>
    </div>
  );
};
